import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

/** Renders children only for the signed-in back-office user; otherwise sends to login. */
export const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div
        data-testid="private-route-loading"
        className="min-h-screen flex items-center justify-center font-mono text-[11px] uppercase tracking-[0.25em] text-mutedink"
      >
        Checking access…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
